import { Routes } from '@angular/router';
import { AuthenticationGuardService } from './auth/guards/authentication-guard';
import { EmployeeTabsComponent } from './modules/personnel-files/employee-tabs/employee-tabs.component';
import { ClassicSandboxComponent } from './shared/iframe/components/classic-sandbox/classic-sandbox.component';

export const delegateRoutes: Routes = [
  {
    path: 'delegate',
    children: [
      {
        path: 'team',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 95
        },
      },
      {
        path: 'reports/trainingemployees',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/en/common/reports/mdwtrainingreport.asp?DOTNET=1&delegate=1',
        },
      },
      {
        path: 'tasks/course/requests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?delegate=1&DOTNET=1&selectedapprovalstage=1&applyfilter=1&chkApprovalPending=on&chkApproved=&chkCCD=on&chkCCWD=on&chkNCC=on&chkElearning=on',
        },
      },
      {
        path: 'development/requests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/EN/common/waitlist/waitlistsearch.asp?DOTNET=1&delegate=1',
        },
      },
      {
        path: 'development/planning/team',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/EN/common/courses/planning.asp?indirrep=0&DOTNET=1&delegate=1&status=1',
        },
      },
      {
        path: 'development/planning/individual',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/student/ML/sharedmenus/mainpages/teamschedule.asp?indirrep=0&DOTNET=1&delegate=1',
        },
      },
      {
        path: 'development/individual-requests',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 16
        },
      },
      {
        path: 'development/current-courses',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 15
        },
      },
      {
        path: 'development/registration/catalog',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            // tslint:disable-next-line: max-line-length
            '/perfnav/student/ML/common/courses/coursecatalog.asp?indirrep=0&DOTNET=1&fillvar=1&search=&foreval=&goal=&delegate=1&from=mgr&student=0',
        },
      },
      {
        path: 'development/registration/on-the-job',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/EN/common/waitlist/createNCC.asp?fromstu=3&indirrep=0&delegate=1&DOTNET=1&linkhit=1',
        },
      },
      {
        path: 'development/registration/groups',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/student/ML/sharedmenus/mainpages/teamcoursegroups.asp?indirrep=0&DOTNET=1&delegate=1',
        },
      },
      {
        path: 'development/registration/finished',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/student/ML/sharedmenus/mainpages/teamschedulecomplete.asp?indirrep=0&DOTNET=1&delegate=1',
        },
      },
      {
        path: 'qualifications',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/en/common/certificates/studentcertificates.asp?DOTNET=1&delegate=1',
        },
      },
      {
        path: 'compliance',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 3
        },
      },
      {
        path: 'team-documents',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 11
        },
      },
      {
        path: 'my-team/positions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/student/ML/common/positions/positionsearch.asp?DOTNET=1&delegate=1',
        },
      },
      {
        path: 'my-team/worklist',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/en/common/dashboard/udfieldworklist.asp?DOTNET=1&delegate=1',
        },
      },
      {
        path: 'my-team/timeline',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          delegate: true,
          classicpath:
            '/perfnav/administration/en/adm/timeline.asp?DOTNET=1&netfilter=1&delegate=1',
        },
      },
      {
        path: 'goals/development-goals',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 38
        },
      },
      {
        path: 'goals/performance-goals',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
          delegate: true,
          menuId: 4
        },
      }
    ],
    canActivate: [AuthenticationGuardService],
  },
];
